export const errorMessages = {
  required: '{{label}} is verplicht.',
  missingat: '{{label}} moet een @ bevatten.',
  email: '{{label}} moet een geldig e-mailadres zijn. Gebruik het formaat jouwnaam@voorbeeld.be.',
  min: 'De waarde van {{label}} moet minstens {{min}} zijn.',
  max: 'De waarde van {{label}} mag maximaal {{max}} zijn.',
};
